import React from 'react';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';
import { HealthBabyPlanDataProvider } from '../../../../Services/HealthBabyPlanDataContext';
import { HealthPlanContextProvider } from '../../../../Services/HealthPlanContext';
import HealthPlanBaby from './HealthPlanBaby';

interface HealthPlanBabyWrapperProps {
	patientId: string;
	workplaceId: string;
	onHealthPlanCreate: () => void;
}

export default function HealthPlanBabyWrapper(
	props: HealthPlanBabyWrapperProps,
): JSX.Element {
	const { patientId, workplaceId, onHealthPlanCreate } = props;

	// TODO: Načíst healthPlanUser do contextu

	return (
		<HealthPlanContextProvider
			values={{
				healthPlan: { code: HealthPlanCode.BABY },
				setHealthPlan: () => {},
				healthPlanUser: undefined,
				setHealthPlanUser: () => {},
				healthPlanData: null,
				setHealthPlanData: () => {},
				activeHealthPlanUserItem: null,
				setActiveHealthPlanUserItem: () => {},
			}}>
			<HealthBabyPlanDataProvider>
				<HealthPlanBaby
					patientId={patientId}
					workplaceId={workplaceId}
					onHealthPlanCreate={onHealthPlanCreate}
				/>
			</HealthBabyPlanDataProvider>
		</HealthPlanContextProvider>
	);
}
